
    const data = {"name":"src/core/icons/image-album","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"m6 19 3-3.86 2.14 2.58 3-3.86L18 19H6M6 4h5v8l-2.5-1.5L6 12M18 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            